export default "__VITE_ASSET__CDfHIgtA__"